import ErrorTemplate from "./ErrorTemplate";

export default function MissingEmailError() {
  return (
    <ErrorTemplate
      title="We're having some difficulty processing your application online"
      content={
        <>
          An email address is needed to apply online. Please login to&nbsp;
          <a href="https://qa2banking.meridiancu.ca/Retail/Banking/Security" target="_blank">
            <span className="active underline">Retail Online Banking</span>
          </a>{" "}
          to add your email address.
        </>
      }
    />
  );
}
